module.exports = __webpack_public_path__ + "static/media/Cyprus.c3182404.png";